
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class AirRoadHeader extends Vue {
  backBtnClicked() {
    this.$emit('backBtnClicked');
  }
}
